import { ChipAwareMarkdown } from '@/markdown/chips';

export interface SectionContainerProps {
  title?: string | null;
  body: string;
}

export function SectionContainer({
  title,
  body,
}: SectionContainerProps): JSX.Element {
  return (
    <section className="tw-text-[14px] tw-text-cal-ink-soft tw-leading-relaxed">
      {title && (
        <h3 className="tw-font-serif tw-text-[15.5px] tw-font-bold tw-text-cal-ink tw-mb-2">
          {title}
        </h3>
      )}
      <ChipAwareMarkdown
        source={body}
      />
    </section>
  );
}
